import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filterNameTree",
    standalone: false
})
/**
 *
 * This pipe filter generic list item by predicate (search text), field (optional, default by field name) and also by extra field which is optional
 * It could be called directly in ngFor costrucor as "ngFor="let element of lists | filterNameTree:searchPredicate""" or
 * "ngFor="let element of lists | filterNameTree:searchPredicate:'description' : 'extraFieldHere'" (es. if i wand filter by description field of single object)
 *
 */
export class FilterNameTreePipe implements PipeTransform {
  transform(
    items: Array<any>,
    predicate: string,
    field?: string,
    extraField?: string
  ): any {
    if (!field) {
      field = "name";
    }

    if (predicate.length >= 2) {
      return items.filter((item) => {
        const fieldValue = item[field] as string;
        const extraFieldValue = item[extraField] as string;

        const matchesInChildren = this.checkChildren(
          item.children,
          predicate,
          field
        );

        if (
          (fieldValue &&
            fieldValue.toUpperCase().includes(predicate.toUpperCase())) ||
          matchesInChildren
        ) {
          return true;
        }

        const matchesInChildrenExtra = item.children?.some((child) => {
          const childField = child[extraField]?.toLowerCase();
          const match = childField?.includes(predicate.toLowerCase());
          return match;
        });

        if (extraField) {
          const matchesExtraInChildren = this.checkChildren(
            item.children,
            predicate,
            extraField
          );
        }

        if (
          extraField &&
          ((extraFieldValue &&
            extraFieldValue.toUpperCase().includes(predicate.toUpperCase())) ||
            matchesInChildrenExtra)
        ) {
          return true;
        }

        return false;
      });
    } else {
      return items;
    }
  }

  private checkChildren(
    children: any[],
    predicate: string,
    field: string
  ): boolean {
    if (!children || children.length === 0) {
      return false;
    }

    return children.some((child) => {
      const childField = child[field]?.toLowerCase();
      const match = childField?.includes(predicate.toLowerCase());
      return match || this.checkChildren(child.children, predicate, field);
    });
  }
}
